/*
 * Accessibility fix — de-duplicate repeated element IDs injected by GemPages.
 * WCAG 4.1.1 (A): every id in a document must be unique.
 *
 * Cause on neauwater.com: the product-card template repeats once per product,
 * and GemPages reuses the same auto-generated element IDs (gp-row, badges,
 * prices, etc.) on each copy. These IDs are cosmetic and are not referenced by
 * any aria-*, label[for], or href="#id", so renaming later duplicates is safe.
 *
 * Strategy: keep the FIRST occurrence of each id untouched; rename the 2nd,
 * 3rd, ... occurrences. Skip any id that something actually references, so we
 * never break a label/aria/anchor relationship.
 */
(function () {
  var REF_ATTRS = [
    'for', 'aria-labelledby', 'aria-describedby', 'aria-controls',
    'aria-owns', 'aria-details', 'aria-flowto', 'headers', 'list'
  ];

  function isReferenced(id) {
    for (var i = 0; i < REF_ATTRS.length; i++) {
      try {
        if (document.querySelector('[' + REF_ATTRS[i] + '~="' + CSS.escape(id) + '"]')) return true;
      } catch (e) {}
    }
    try {
      if (document.querySelector('a[href="#' + CSS.escape(id) + '"]')) return true;
    } catch (e) {}
    return false;
  }

  function dedupeIds() {
    var seen = Object.create(null);
    var nodes = document.querySelectorAll('[id]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var id = el.getAttribute('id'); // getAttribute avoids the form.id pitfall
      if (!id) continue;

      if (seen[id]) {
        if (isReferenced(id)) continue; // leave referenced IDs alone
        var n = seen[id]++;
        var newId = id + '-dup' + n;
        while (document.getElementById(newId)) { newId = id + '-dup' + (++n); }
        el.setAttribute('id', newId);
      } else {
        seen[id] = 1;
      }
    }
  }

  function run() {
    dedupeIds();
    // GemPages renders asynchronously — re-run after a short settle delay.
    setTimeout(dedupeIds, 800);
    setTimeout(dedupeIds, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
})();
